import { AfterViewInit, Directive, ElementRef, HostBinding, Input, Renderer2 } from '@angular/core';
import { MatIcon } from '@angular/material/icon';

@Directive({
    selector: '[appSocialFormIcon]',
    standalone: false
})
export class SocialFormIconDirective implements AfterViewInit {

  @Input() set type(type: string) {
    this.iconType = type.toLowerCase()
    this.ngAfterViewInit()
  }

  constructor(private readonly icon: MatIcon) { }

  ngAfterViewInit() {
    this.icon.svgIcon = this.iconType;
  }

  iconType: string = '';

}
